import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { CollapsedContext } from "../../../Context/CollapsedContext";
import { getUserMenu } from "../../../Service/MenuAPI";

const { SubMenu } = Menu;

const MenuComponents = () => {
  const [menuList, setMenuList] = useState([]);
  const { onCollapse } = useContext(CollapsedContext);
  const navigate = useNavigate();
  const [MenuOpen, setMenuOpen] = useState({
    key: "useMenuOpen",
    default: {
      data: ["sub1"],
    },
  });

  const userDiv = localStorage.getItem("userDiv");

  useEffect(() => {
    const loadMenuData = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        return;
      }

      try {
        const menuData = await getUserMenu(userDiv);
        if (Array.isArray(menuData)) {
          setMenuList(menuData);
        } else {
          setMenuList([]);
        }
      } catch (error) {
        setMenuList([]);
      }
    };
    loadMenuData();
  }, []);

  const handleClick = (e) => {
    navigate(e.key);
    onCollapse();
  };

  // 메뉴 항목 생성
  const items = [
    {
      key: "sub1",
      icon: <UserOutlined />,
      label: "생장물 시스템",
      children: menuList.map((menu) => ({
        key: menu.menuPath, // 경로를 key로 사용
        label: menu.menuNm, // 메뉴 이름
      })),
    },
  ];

  return (
    <Menu
      mode="inline"
      onClick={handleClick}
      defaultOpenKeys={["sub1"]}
      openKeys={MenuOpen.data}
      items={items} // Ant Design의 최신 방식
      style={{ fontFamily: "Gmarketsans" }}
    ></Menu>
  );
};

export default MenuComponents;
